export function initCustomElements() {


    customElements.define("div-data-handler",
        class extends HTMLElement {
            constructor() { super(); }

            connectedCallback() {
                for (let item in this.dataset) {
                    if (item.substring(0, 2) === "on") {
                        var evt = item.substring(2);
                        var controller = this.dataset.controller;
                        var action = this.dataset[item];
                        this.addEventListener(evt, event => (<any>window)[controller][action](event));
                    }
                }
            }
        }
    );

    // We can't access the parent when the event is fired, so use a work queue to get the job done
    const workQueue = [];

    customElements.define("div-parent-data-handler",
        class extends HTMLElement {
            constructor() { super(); }

            connectedCallback() {
                workQueue.push(this);
            }
        }
    );

    window.setInterval(() => {

        const deferred = [];

        for(var element = workQueue.pop(); element; element = workQueue.pop()) {

            var parent = element.parentElement;
            if(parent) {

                // element has a dataset property called offset. Get the parent element that many jumps away
                const offset = parseInt(element.dataset.offset);
                for(var i = 1; i < offset; i++) {
                    parent = parent.parentElement;
                }

                for (let item in element.dataset) {
                    if (item.substring(0, 2) === "on") {
                        let evt = item.substring(2);
                        let controller = element.dataset.controller;
                        let action = element.dataset[item];
                        parent.addEventListener(evt, event => (<any>window)[controller][action](event));
                    }
                }

            } else {
                deferred.push(element);
            }
        }

        deferred.forEach(element => workQueue.push(element));

    }, 250);

}